// Home Page Summaries for Project Cards
// These are the short descriptions shown in the projects showcase grid

const projectHomeSummaries = {
  'SighedKick': {
    title: 'SighedKick',
    description: 'A constantly evolving GenAI workspace where I design, build, and stress-test how AI should actually plug into real workflows. I use SighedKick daily as my own copilot—storing prompts, shaping tone, and drafting everything from Slack messages to PRDs—while using the same system as a testbed for multi-LLM architectures, evals, and human–AI collaboration patterns.',
    icon: 'fa-robot',
    iconColor: 'cyan-400',
    technologies: ['TypeScript', 'Next.js', 'OpenAI API']
  },
  'ByteMe': {
    title: 'ByteMe',
    description: 'ByteMe is a native iOS nutrition tracker that borrows patterns from financial monitoring—turning daily food logging into a clean, insight-driven experience. I built it both as a real health tool I use every day and as a sandbox to prototype ideas for personal finance monitoring: frictionless entry, trend visualization, and habit-forming feedback loops.',
    icon: 'fa-mobile-alt',
    iconColor: 'cyan-400',
    technologies: ['Swift', 'SwiftUI', 'iOS']
  },
  'CKFD': {
    title: 'Demo App: Personalized Feed Engagement',
    description: 'A high-fidelity, mobile-first React prototype that explores how personalized content feeds can drive engagement in financial wellness apps. Built as a rapid-iteration sandbox for testing product directions and validating UX patterns.',
    icon: 'fa-chart-line',
    iconColor: 'purple-400',
    technologies: ['React', 'TypeScript', 'MUI']
  },
  'EmptyMyInbox': {
    title: 'Empty my Inbox',
    description: 'A unified email productivity tool that pulls multiple Gmail accounts into one fast, opinionated interface, designed to make Inbox Zero something you can actually hit every day—ideally in the time it takes to ride BART.',
    icon: 'fa-inbox',
    iconColor: 'purple-400',
    technologies: ['Django', 'React', 'PostgreSQL']
  },
  'PRDSystem': {
    title: 'AI-Assisted PRD Workflow',
    description: 'A lightweight, GenAI-powered workflow I designed to turn messy, spoken ideas into clean, structured PRDs. The system combines voice transcripts, targeted AI prompts, and guided refinement so PMs can go from "I have a half-formed idea" to "I have an update-ready PRD" in under an hour—without staring at a blank doc.',
    icon: 'fa-file-alt',
    iconColor: 'cyan-400',
    technologies: ['GenAI', 'Workflow Design', 'Product Management']
  },
  'CanadianEconomy': {
    title: 'Canadian Economic Performance',
    description: 'An interactive data story exploring key Canadian macroeconomic indicators over time, originally built as a Jupyter visualization and exported to the web so people can explore trends and relationships directly in the browser.',
    icon: 'fa-chart-bar',
    iconColor: 'cyan-400',
    technologies: ['Python', 'Jupyter', 'Data Visualization']
  },
  'Kakeibo': {
    title: 'Kakeibo',
    description: 'A small, opinionated personal finance prototype that brings the Japanese kakeibo money journaling method into a simple digital experience—emphasizing reflection and intention over dense budgeting dashboards.',
    icon: 'fa-wallet',
    iconColor: 'purple-400',
    technologies: ['Python', 'Jupyter', 'Behavior Design']
  },
  'UWEngineeringProgramClassifier': {
    title: 'Engineering Fit Classifier',
    description: 'An applied ML demo that wraps a simple classifier in a UX for suggesting University of Waterloo engineering programs based on student interests and attributes—more conversation starter than oracle.',
    icon: 'fa-university',
    iconColor: 'cyan-400',
    technologies: ['Python', 'scikit-learn', 'Data Science']
  },
  'UWPlacementQuiz': {
    title: 'What Type of Engineering Should I Study?',
    description: 'A lightweight, browser-based quiz that helps prospective students think through which UW programs might fit them, using structured questions and transparent scoring instead of a black-box model.',
    icon: 'fa-question-circle',
    iconColor: 'purple-400',
    technologies: ['JavaScript', 'UX', 'Decision Support']
  },
  'MakingYourOwnCopilot': {
    title: 'Making Your Own AI Copilot',
    description: 'A hands-on workshop I designed and delivered to help product managers, engineers, and operators build their own AI copilots—personalized systems that leverage LLMs as context-rich, persistent partners for their work.',
    icon: 'fa-chalkboard-teacher',
    iconColor: 'cyan-400',
    technologies: ['Workshop Design', 'GenAI', 'Education']
  }
};

export default projectHomeSummaries;

